// extracted by mini-css-extract-plugin
export default {"container":"Message_container__n4uTQ","user":"Message_user__ruqMr","message":"Message_message__UdveK"};